export enum PixFavoredMenu {
	PHONE,
	CPFCNPJ,
	EMAIL,
	EVP,
	ACCOUNT
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/favored-menu.enum.ts